import ReactDOM from 'react-dom';
import './index.scss';
import './reset.min.scss';
import { BrowserRouter } from 'react-router-dom';
import HttpsRedirect from 'react-https-redirect';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import App from './App';
import store from './state/store';
import mockServiceWorker from './mocks/browser';

if (process.env.NODE_ENV === 'development') {
  void mockServiceWorker.start();
}

const persistor = persistStore(store);

const basename = window.location.pathname.split('/');

ReactDOM.render(
  <HttpsRedirect>
    <BrowserRouter basename={basename[1]}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </HttpsRedirect>,
  document.getElementById('root'),
);

serviceWorkerRegistration.register();
